import loader from "checklists/loader"
import excavator from "checklists/excavator"
import rockTruck from "checklists/rockTruck"
import crane from "checklists/crane"
import pickup from "checklists/pickup"
import towedTrailer from "checklists/towedTrailer"
import general from "checklists/general"
import singleUnitTruck from "checklists/singleUnitTruck"
import smallPassengerVehicle from "checklists/smallPassengerVehicle"
import schoolbus from "checklists/schoolbus"
import generalTractor from "checklists/generalTractor"
import motorCoach from "checklists/motorCoach"
import mower from "checklists/mower"

export const getType = (number, customInspections) => {

    if (number in customInspections) {
        let customInspection = customInspections[number]

        return customInspection.type
    }

    return "N/A"
}

export const getStatus = (number) => {
    if (number === "0") {return "Good";}
    if (number === "1") {return "Monitor";}
    if (number === "2") {return "Needs Repair";}

    return "Good";
};

export const fallbackOptions =  [
    { key: 0, target: { value: "001", name: 'type' }, label: 'Loader'},
    { key: 1, target: { value: "002", name: 'type' }, label: 'Excavator'},
    { key: 2, target: { value: "003", name: 'type' }, label: 'Rock Truck'},
    { key: 3, target: { value: "004", name: 'type' }, label: 'Crane'},
    { key: 4, target: { value: "005", name: 'type' }, label: 'Pickup Truck'},
    { key: 5, target: { value: "006", name: 'type' }, label: 'Towed Trailer'},
    { key: 6, target: { value: "007", name: 'type' }, label: 'General'},
    { key: 7, target: { value: "008", name: 'type' }, label: 'Single Unit Truck'},
    { key: 8, target: { value: "009", name: 'type' }, label: 'Small Passenger Vehicle'},
    { key: 9, target: { value: "010", name: 'type' }, label: 'School Bus'},
    { key: 10, target: { value: "011", name: 'type' }, label: 'General Tractor'},
    { key: 11, target: { value: "012", name: 'type' }, label: 'Motor Coach'},
    { key: 12, target: { value: "013", name: 'type' }, label: 'Mower'},
];

export const templateOptions =  [
    { key: -1, target: { value:"0", name: 'type', }, label: 'None'},
    { key: 0, target: { value: {name: "000", data: loader }, name: 'type', }, label: 'Loader'},
    { key: 1, target: { value: {name: "001", data: excavator}, name: 'type', }, label: 'Excavator'},
    { key: 2, target: { value: {name: "002", data: rockTruck}, name: 'type', }, label: 'Rock Truck'},
    { key: 3, target: { value: {name: "003", data: crane}, name: 'type', }, label: 'Crane'},
    { key: 4, target: { value: {name: "004", data: pickup}, name: 'type', }, label: 'Pickup Truck'},
    { key: 5, target: { value: {name: "005", data: towedTrailer}, name: 'type', }, label: 'Towed Trailer'},
    { key: 6, target: { value: {name: "006", data: general}, name: 'type',  }, label: 'General'},
    { key: 7, target: { value: {name: "007", data: singleUnitTruck}, name: 'type', }, label: 'Single Unit Truck'},
    { key: 8, target: { value: {name: "008", data: smallPassengerVehicle}, name: 'type', }, label: 'Small Passenger Vehicle'},
    { key: 9, target: { value: {name: "009", data: schoolbus}, name: 'type', }, label: 'School Bus'},
    { key: 10, target: { value: {name: "010", data: generalTractor}, name: 'type', }, label: 'General Tractor'},
    { key: 11, target: { value: {name: "011", data: motorCoach}, name: 'type', }, label: 'Motor Coach'},
    { key: 12, target: { value: {name: "012", data: mower}, name: 'type', }, label: 'Mower'},
];

export const createOptions = (customInspections) => {
    let options = [
        // { key: 0, target: { value: "001", name: 'type' }, label: 'Loader'},
        // { key: 1, target: { value: "002", name: 'type' }, label: 'Excavator'},
        // { key: 2, target: { value: "003", name: 'type' }, label: 'Rock Truck'},
        // { key: 3, target: { value: "004", name: 'type' }, label: 'Crane'},
        // { key: 4, target: { value: "005", name: 'type' }, label: 'Pickup Truck'},
        // { key: 5, target: { value: "006", name: 'type' }, label: 'Towed Trailer'},
        // { key: 6, target: { value: "007", name: 'type' }, label: 'General'},
        // { key: 7, target: { value: "008", name: 'type' }, label: 'Single Unit Truck'},
        // { key: 8, target: { value: "009", name: 'type' }, label: 'Small Passenger Vehicle'},
        // { key: 9, target: { value: "010", name: 'type' }, label: 'School Bus'},
        // { key: 10, target: { value: "011", name: 'type' }, label: 'General Tractor'},
        // { key: 11, target: { value: "012", name: 'type' }, label: 'Motor Coach'},
        // { key: 12, target: { value: "013", name: 'type' }, label: 'Mower'},
    ];

    for (let id in customInspections) {
        let customInspection = customInspections[id]

        options.push({
            key: id,
            target: { 
                value: id,
                name: 'type'
            },
            label: customInspection.type
        })
    }

    return options
}

export const summaryTabNames = [
	{label: 'Summary', page: '/'},
	{label: 'Add New Vehicle', page: '/newvehicle'},
    {label: 'Generate QR-Codes', page: '/qrcodes'},
    {label: 'Custom Inspections', page: '/newinspection'}
]

export const vehicleTabNames = (search, genQRCode) => [
    {label: 'Details', page: `/vehicle?${search}`},
    {label: 'Edit', page: `/editvehicle?${search}`},
    {label: 'Notifications', page: `/notificationvehicle?${search}`},
    {label: 'Download Vehicle Audit', page:`/audits?${search}`},
    {label: 'Download Vehicle QR-Code', fn: genQRCode}, 
]

export const customInspectionTabNames =  [
    {label: 'Create Custom Inspection', page:`/newinspection`},
    {label: 'Edit Custom Inspection', page: `/editinspection`}
]

export const PDF_PAGE_SIZE = 50;

